"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYMap = void 0;
exports.scaleRect = scaleRect;
exports.constrainRect = constrainRect;
exports.normalizeRect = normalizeRect;
exports.constrainValue = constrainValue;
exports.valueBetween = valueBetween;
exports.max = max;
exports.maxA = maxA;
exports.min = min;
exports.constrainPositive = constrainPositive;
exports.assertInteger = assertInteger;
exports.booleanXor = booleanXor;
exports.combineMirrors = combineMirrors;
exports.distanceBetweenPoints = distanceBetweenPoints;
exports.distanceBetweenIPoints = distanceBetweenIPoints;
function scaleRect(rect, scale) {
    return {
        x1: rect.x1 * scale,
        x2: rect.x2 * scale,
        y1: rect.y1 * scale,
        y2: rect.y2 * scale,
    };
}
function constrainRect(rect, boundingRect) {
    rect = normalizeRect(rect);
    boundingRect = normalizeRect(boundingRect);
    return {
        x1: constrainValue(boundingRect.x1, rect.x1, boundingRect.x2),
        x2: constrainValue(boundingRect.x1, rect.x2, boundingRect.x2),
        y1: constrainValue(boundingRect.y1, rect.y1, boundingRect.y2),
        y2: constrainValue(boundingRect.y1, rect.y2, boundingRect.y2),
    };
}
function normalizeRect(rect) {
    return {
        x1: min(rect.x1, rect.x2),
        x2: max(rect.x1, rect.x2),
        y1: min(rect.y1, rect.y2),
        y2: max(rect.y1, rect.y2),
    };
}
function constrainValue(min, value, max) {
    if (min > max) {
        const tmp = min;
        min = max;
        max = tmp;
    }
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
function valueBetween(min, value, max, numEpsilons = 2) {
    if (min > max) {
        const tmp = min;
        min = max;
        max = tmp;
    }
    return !(value < min + numEpsilons * Number.EPSILON || value > max + numEpsilons * Number.EPSILON);
}
function max(a, b) {
    if (typeof a !== 'number') {
        if (typeof b === 'number') {
            return b;
        }
        return Number.NaN;
    }
    if (typeof b !== 'number') {
        return a;
    }
    if (a > b) {
        return a;
    }
    return b;
}
function maxA(...a) {
    if (a.length === 0) {
        return Number.NaN;
    }
    let max = a[0];
    for (let i = 1; i < a.length; ++i) {
        if (a[i] > max) {
            max = a[i];
        }
    }
    return max;
}
function min(a, b) {
    if (typeof a !== 'number') {
        if (typeof b === 'number') {
            return b;
        }
        return Number.NaN;
    }
    if (typeof b !== 'number') {
        return a;
    }
    if (a < b) {
        return a;
    }
    return b;
}
function constrainPositive(num) {
    if (typeof num !== 'number') {
        return 0;
    }
    if (num < 0) {
        return 0;
    }
    return num;
}
function assertInteger(maybeNum) {
    if (typeof maybeNum === 'string') {
        return parseInt(maybeNum);
    }
    return maybeNum;
}
function booleanXor(a, b) {
    return (a || b) && !(a && b);
}
function combineMirrors(a, b) {
    return [booleanXor(Boolean(a && a[0]), Boolean(b && b[0])), booleanXor(Boolean(a && a[1]), Boolean(b && b[1]))];
}
function distanceBetweenPoints(a, b) {
    return Math.sqrt(Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2));
}
function distanceBetweenIPoints(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
}
class XYMap {
    constructor() {
        this.points = new Map();
    }
    set(x, y, val) {
        if (!this.points.has(x)) {
            this.points.set(x, new Map([[y, val]]));
            return;
        }
        const xMap = this.points.get(x);
        xMap.set(y, val);
    }
    has(x, y) {
        return Boolean(this.points.get(x)?.has(y));
    }
    get(x, y) {
        return this.points.get(x)?.get(y);
    }
    *values() {
        for (const yMap of this.points.values()) {
            for (const val of yMap.values()) {
                yield val;
            }
        }
    }
    *entries() {
        for (const [x, yMap] of this.points.entries()) {
            for (const [y, val] of yMap.entries()) {
                yield [x, y, val];
            }
        }
    }
}
exports.XYMap = XYMap;
//# sourceMappingURL=Utils.js.map